import { Box, BoxProps, Skeleton } from '@mui/material'
import useCellImageLayerUrl from 'utils/useCellImageLayerUrl'
import { getCellImageInfoFromCellId } from './tsv/utils'

const RAW_CROP_LAYER = 'raw_crop'

interface PlotCellRawImageProps {
  /** cellId string in the `timestamp_instrumentid_number_frame` form */
  cellId: string
  imgProps?: React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>
  wrapperProps?: BoxProps
  /** Only fetch when enabled (the raw layer is internal + allowlisted-run only) */
  enabled?: boolean
}

/**
 * Renders a cell's raw (unmasked) crop from the `raw_crop` image layer, using the
 * same cellId-string form the labeling grid works with. Sibling to PlotCellImage,
 * which renders the masked crop.
 */
export const PlotCellRawImage = ({
  cellId,
  imgProps,
  wrapperProps,
  enabled = true,
}: PlotCellRawImageProps): JSX.Element => {
  const { cellId: protoCellId, frame } = getCellImageInfoFromCellId(cellId)
  const { data: rawImageUrl } = useCellImageLayerUrl(protoCellId, RAW_CROP_LAYER, frame, enabled)

  return (
    <Box component="span" sx={{ display: 'inline-flex', p: '2px' }} {...wrapperProps}>
      {rawImageUrl ? (
        <img
          data-testid="plotCellRawImageImgElement"
          src={rawImageUrl}
          width={imgProps?.width}
          alt="raw crop"
          {...imgProps}
        />
      ) : (
        <Skeleton
          data-testid="plotCellRawImageSkeleton"
          variant="rectangular"
          width={imgProps?.width}
          height={imgProps?.height}
          style={imgProps?.style}
        />
      )}
    </Box>
  )
}

export default PlotCellRawImage
